/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/import-whitelist
import { NOT_FOUND } from '@jira/platform__http-status-codes/src/http-status-codes.tsx';
import { getProjectKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import {
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { performGetRequest } from '@atlassian/jira-fetch';

// We use 1/0 to reduce characters as user preferences has a 255 limit
export type IssueSelectedTabData = {
	default?: string; // default selected tab
	[issueType: string]: string | undefined; // selected per issue type, to enable TODO BENTO-9507: This should be keyed differently as a project can have issue types with different tabs
};

const getKey = ({ match, query }: { match: Match; query: Query }) => {
	const projectKey = getProjectKey(match, query);
	return `issue.selected-tab.${projectKey}`;
};

export const issueSelectedTabDataResource: RouteResource<IssueSelectedTabData | undefined> =
	createResource<IssueSelectedTabData | undefined>({
		type: 'ISSUE_SELECTED_TAB_DATA',
		getKey,
		getData: async ({ match, query }) => {
			const key = getKey({ match, query });
			const requestUrl = `/rest/api/3/mypreferences?key=${key}`;

			try {
				return await performGetRequest(requestUrl);
			} catch (error) {
				if (
					!!error &&
					typeof error === 'object' &&
					'statusCode' in error &&
					error.statusCode === NOT_FOUND
				) {
					return;
				}

				throw createResourceError(
					{
						component: 'spa.view.routes.issue-view.selected-tab.getData',
						message: 'An error was thrown while prefetching issue selected tab data',
					},
					error,
				);
			}
		},
	});
